import { apiRequest } from './index';

export const statsAPI = {
  getDashboardStats: (startDate, endDate, employeeId = 'all') => {
    const params = new URLSearchParams({ startDate, endDate, employeeId });
    return apiRequest(`/dashboard?${params}`);
  },

  getUserStats: (userId) => apiRequest(`/stats/user/${userId}`)
};